import React from 'react';

// Lock icon from the Buy Now, Pay Later design. Uses `currentColor` so it
// inherits the colour set on the surrounding circle.
const LockIcon = () => (
  <svg
    width="28"
    height="32"
    viewBox="0 0 23.8333 27.1667"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M5.91667 10.7507H17.9167M5.91667 10.7507V7.25C5.91667 3.93629 8.60296 1.25 11.9167 1.25C15.2304 1.25 17.9167 3.93629 17.9167 7.25V10.7507M5.91667 10.7507H3.25C2.14543 10.7507 1.25 11.6461 1.25 12.7507V20.5833C1.25 23.5289 3.63781 25.9167 6.58333 25.9167H17.25C20.1955 25.9167 22.5833 23.5289 22.5833 20.5833V12.7507C22.5833 11.6461 21.6879 10.7507 20.5833 10.7507H17.9167M11.9167 21.9167C11.3644 21.9167 10.9167 21.469 10.9167 20.9167V18.9167C10.9167 18.3644 11.3644 17.9167 11.9167 17.9167C12.469 17.9167 12.9167 18.3644 12.9167 18.9167V20.9167C12.9167 21.469 12.469 21.9167 11.9167 21.9167Z"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LockIcon;
